import React from "react";
import styled from "styled-components/macro";

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

export const ButtonsGroupContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.softGray};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.bgSecondary};
  padding: 4px;
  display: flex;
  gap: 2px;
`;

export const Button = styled.button<IButton>`
  border: 1px solid
    ${(props) =>
      props.selected
        ? props.theme.colors.textDimmed
        : props.theme.colors.bgSecondary};
  outline: none;
  padding: 5px 32px;
  border-radius: 6px;
  transition: 0.3s;
  background: ${(props) => props.theme.colors.bgSecondary};
  display: flex;
  align-items: center;

  & > span {
    position: relative;
  }

  &:hover {
    cursor: pointer;
  }

  font-family: ${({ theme }) => theme.text.family};
  line-height: ${({ theme }) => theme.text.defaultLineHeight};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.font.weightMedium};

  color: ${({ theme, selected }) =>
    selected ? theme.colors.text : theme.colors.textDimmed};

  @media ${({ theme }) => theme.media.phone} {
    font-weight: ${({ theme }) => theme.text.default.mobileWeight};
  }

  svg {
    width: 20px;
    height: auto;
    margin-right: 10px;
  }
`;
